module.exports = __webpack_public_path__ + "static/financial-information-hero-desktop.e8ae85c3.webp";